/**
 * Afișează fraza de recuperare (12 cuvinte numerotate) cu acțiunile de
 * salvare: copiere (clipboard golit după 30s) și descărcare ca fișier .txt.
 * Folosită la înregistrare și la revederea frazei din pagina Cont.
 */
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { copySecret } from '@/lib/clipboard';
import { downloadRecoveryKit } from '@/lib/recoveryKit';

interface Props {
  phrase: string;
  email: string;
}

export default function RecoveryPhraseCard({ phrase, email }: Props) {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);
  const words = phrase.split(' ');

  const download = () => downloadRecoveryKit(phrase, email, t);

  return (
    <div className="space-y-3">
      <ol
        className="grid grid-cols-2 sm:grid-cols-3 gap-2 font-mono text-sm"
        data-testid="recovery-phrase"
        data-phrase={phrase}
      >
        {words.map((word, i) => (
          <li
            key={i}
            className="rounded px-2 py-1.5 border border-[var(--border)] bg-[var(--bg-surface)]"
          >
            <span className="text-[var(--text-dim)] mr-2 select-none">{i + 1}.</span>
            {word}
          </li>
        ))}
      </ol>
      <div className="flex flex-wrap gap-2">
        <button
          type="button"
          className="btn-outline text-xs"
          data-testid="recovery-download"
          onClick={download}
        >
          {t('recovery.download')}
        </button>
        <button
          type="button"
          className="btn-outline text-xs"
          onClick={async () => {
            await copySecret(phrase);
            setCopied(true);
          }}
        >
          {copied ? t('recovery.copied') : t('recovery.copy')}
        </button>
      </div>
    </div>
  );
}
